import * as moment from 'moment';
import * as numeral from 'numeral/numeral';
import {Moment} from "moment";

export class Formatters {
    static maxAllowedDecimalPlaces = 5;

    //# convert datetime C# string to date if val is moment
    static dateFormatter = (row, cell, val) => val ? (moment.isMoment(val) ? val.format('L') : val) : '';

    //# convert datetime C# string to date if val is moment or string
    static dateFormatterConv = (row, cell, val) => val ? moment.isMoment(val) ? val.format('L') : moment.utc(val).format('L') !== 'Invalid date' ? moment.utc(val).format('L') : '' : '';

    //# convert datetime C# string to dateTime string if val is moment
    static datetimeFormatter = (row, cell, val) => val ? (moment.isMoment(val) ? val.format('L LT') : val) : '';

    //# convert datetime C# string to Time string if val is moment
    static timeFormatter = (row, cell, val) => {
        return val ?
            (moment.isMoment(val) ?
                val.format('LT') :
                moment.isDuration(val) ?
                    moment.utc(val.asMilliseconds()).format('LT') :
                    val)
            : ''
    };

    //# convert datetime C# string to dateTime string if val is moment or string
    static dateTimeFormatterConv = (row, cell, val) => val ? moment.isMoment(val) ? val.format('DD.MM.YYYY HH:mm:ss') : moment.utc(val).format('DD.MM.YYYY HH:mm:ss') !== 'Invalid date' ? moment.utc(val).format('DD.MM.YYYY HH:mm:ss') : '' : '';

    //static numberFormatterTwoDecimal = (row, cell, val) => val != null ? numeral(val).format('0,0.00') : '';

    //static numberFormatterThreeDecimal = (row, cell, val) => val != null ? numeral(val).format('0,0.000') : '';

    //static numberFormatterFourDecimal = (row, cell, val) => val != null ? numeral(val).format('0,0.0000') : '';

    //static numberFormatterInteger = (row, cell, val) => val != null ? numeral(val).format('0,0') : '';

    static readonly checkedCssClass = 'fa-check-square-o';
    static readonly uncheckedCssClass = 'fa-square-o';

    //# convert boolean data aweasome icon checkbox
    static booleanFormatter = (row, cell, val) => `<i class="fa ${val ? Formatters.checkedCssClass : Formatters.uncheckedCssClass}"></i>`;

    //# convert boolean data aweasome icon checkbox
    static booleanFormatterText = (row, cell, val, tr: string, fl: string) => `${val ? tr : fl}`;

    //# convert boolean data to checkbox
    static checkBoxFormatter = (row, cell, val) => `<div class="out-chkb-wrp"><label class="chkb-wrp"><input class="chkb" type="checkbox" ${val ? 'checked': ''}><span></span></label></div>`;

    //# convert num data to string with needed decimal
    static numberFormatter = (row: number, cell: number, val: any, decimalPlaces: number) =>
        val != null
            ? numeral(val).format(Formatters.getNumeralFormatString(decimalPlaces))
            : '';

    //# convert num data to string, if conversion can be completed return string with needed decimal
    static numberCustomFormatter = (row: number, cell: number, val: any, decimalPlaces: number) => {
        let res = parseFloat(val);
        return !isNaN(res)
            ? numeral(res).format(Formatters.getNumeralFormatString(decimalPlaces))
            : val;
    };

    //# return needed quantity of zeros
    static getNumeralFormatString = (decimalPlaces: number): string => {
        return `0,0${decimalPlaces > 0
            ? `.${new Array(Math.min(decimalPlaces, Formatters.maxAllowedDecimalPlaces) + 1).join('0')}`
            : ''}`;
    };

    //# format number to percent
    static percentFormatter = (row, cell, val): string => {
        return val ? `${Math.round(Number(val))}%` : val === 0 || val === '0' ? `${val}%` : '';
    };

    static stringCombinerFormatter = (row, cell, val, word, addText, container, translate, data, itemId): string => {
        if (!data) {
            return val;
        }

        let text = [];
        data.analogsWarning && ['analogCode1', 'analogCode2', 'analogCode3'].includes(itemId) && text.push(translate.AnalogsWarning);
        data.notMTSAtSomeWrhWarning1 && itemId === 'activeItems' && text.push(translate.NotMTSAtSomeWrhWarning1);
        data.partialSkuSupplierWarning1 && itemId === 'pricesCount' && text.push(translate.PartialSkuSupplierWarning1);
        data.notMTSAtSomeWrhWarning2 && itemId === 'activeItems' && text.push(translate.NotMTSAtSomeWrhWarning2);
        data.partialSkuSupplierWarning2 && itemId === 'pricesCount' && text.push(translate.PartialSkuSupplierWarning2);
        data.notPresentAtSomeWrhWarning && itemId === 'skuCode' && text.push(translate.NotPresentAtSomeWrhWarning);

        return `<span data-toggle="tooltip" data-html="true" data-container="${container}" title="${text.join('<br>')}">${val} ${word} ${addText}</span>`;
    };

    static translateFormatter = (row, cell, val, translate): string => {
        return `${translate[val]}`;
    };
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/formatters.ts